// @flow

import React, { Component } from 'react';
import { Tabs, Tab, Grid, Row, Col, PageHeader } from 'react-bootstrap/lib';
import Relay from 'react-relay';
import moment from 'moment';

import { Spinner, Card, Calendar, Favourite, CreateEventModal, CreateEventBtn } from './index';


const startToday = moment().startOf('day');
const endToday = moment().endOf('day');

const uiState = {
  startDate: startToday,
  endDate: endToday,
};

type Props = {
  viewer: Object,
  selectedContactEmail: string,
  languagedata: Object,
  relay: Object,
  me: Object,
}
let state;

class ContactInfo extends Component {
  constructor(props: Props) {
    super(props);
    if (!state) {
      this.state = {
        calendarStartDate: startToday,
        calendarEndDate: endToday,
        defaultTab: 1,
        isCreateEventModalOpen: false,
        dateSelectedToCreateEvent: {},
      };
      state = this.state;
    }
    this.state = state;
  }

  state: {
    calendarStartDate: moment,
    calendarEndDate: moment,
    defaultTab: number,
    isCreateEventModalOpen: boolean,
    dateSelectedToCreateEvent: Object,
  };

  componentWillUnmount() {
    state = this.state;
  }

  _updateEvents = (args: Object) : void => {
    const startDate = args.start;
    const endDate = args.end;

    this.props.relay.setVariables({
      selectedContactEmail: this.props.selectedContactEmail,
      startDate,
      endDate,
    });
    this._calendarUIStateSetDateRange(startDate, endDate);
  }

  _calendarUIStateSetDateRange = (startDate, endDate) => {
    uiState.startDate = startDate;
    uiState.endDate = endDate;
    this.setState({
      calendarStartDate: startDate,
      calendarEndDate: endDate,
    });
  }
  _handleSelect = (eventKey: any) => {
    this.setState({
      defaultTab: eventKey,
    });
  }

  _closeCreateEventModal = () => {
    this.setState({ isCreateEventModalOpen: false });
  }

  _modalMakeNewEvent = () => {
    const date = {
      start: moment().format(),
      end: moment().add(1, 'hour').format(),
      hour: moment().format('H'),
    };
    this.setState({
      isCreateEventModalOpen: true,
      dateSelectedToCreateEvent: date,
    });
  }

  _forceFetch = () => {
    this.props.relay.forceFetch();
    this.setState({
      isCreateEventModalOpen: false,
    });
  }

  render() {
    const { me } = this.props;
    const { defaultTab } = this.state;
    const lang = this.props.languagedata;
    const { pendingVariables } = this.props.relay;
    const { contact, meetingRooms } = this.props.viewer;
    const diff = this.state.calendarEndDate.diff(this.state.calendarStartDate, 'days');

    let displayName;
    let events;
    let cardContact;

    let initialView = '';
    if (diff === 0) {
      initialView = 'listDay';
    } else if (diff === 6) {
      initialView = 'listWeek';
    } else {
      initialView = 'month';
    }
    // this needed because viewer.meetingRooms/otherResources are connections when viewer.contact is not
    if (contact) {
      displayName = this.props.viewer.contact.displayName;
      events = this.props.viewer.contact.events;
      cardContact = this.props.viewer.contact;
    } else if (meetingRooms) {
      const room = this.props.viewer.meetingRooms.edges[0].node;
      displayName = room.displayName;
      events = room.events;
      cardContact = room;
    } else {
      const resource = this.props.viewer.otherResources.edges[0].node;
      displayName = resource.displayName;
      events = resource.events;
      cardContact = resource;
    }

    return (
      <div>
        <CreateEventBtn handlerFunc={this._modalMakeNewEvent} tipText={lang.create_new_event} />
        <PageHeader>{displayName}</PageHeader>
        <Grid fluid className="user-tool-menu">
          <Row>
            <Col md={12} className="text-right">
              <Favourite
                language={lang}
                favourite={this.props.viewer}
                selectedContactEmail={this.props.relay.variables.selectedContactEmail}
              />
            </Col>
          </Row>
        </Grid>
        <Tabs
          activeKey={defaultTab}
          onSelect={this._handleSelect}
          id="view-tab"
        >
          <Tab eventKey={1} title={lang.calendar}>
            { pendingVariables ? <Spinner /> : null }
            <Calendar
              languagedata={lang}
              events={events}
              startDate={this.state.calendarStartDate}
              endDate={this.state.calendarEndDate}
              initialView={initialView}
              updateEvents={this._updateEvents}
              showCalendar={defaultTab}
              me={me}
            />
          </Tab>
          <Tab eventKey={2} title={lang.card}>
            <Card contact={cardContact} languagedata={lang} />
          </Tab>
        </Tabs>
        {this.state.isCreateEventModalOpen ? (
          <CreateEventModal
            isCreateEventModalOpen={this.state.isCreateEventModalOpen}
            dateSelectedToCreateEvent={this.state.dateSelectedToCreateEvent} // { end: date, start: date, hour: number}
            LocalLanguageData={lang}
            viewer={this.props.viewer}
            closeCreateEventModal={() => this._closeCreateEventModal()}
            contactsSelected={[cardContact]}
            contact={me}
            forceFetch={this._forceFetch}
          />
        ) : (null)}
      </div>
    );
  }
}

export default Relay.createContainer(ContactInfo, {
  initialVariables: {
    selectedContactEmail: null,
    startDate: null,
    endDate: null,
    showMeetingRoom: false,
    showOtherResource: false,
    emails: [null],
  },
  prepareVariables: vars => {
    const startDate = moment.isMoment(vars.startDate) ? (
      vars.startDate.unix()
    ) : (
      uiState.startDate.unix()
    );
    const endDate = moment.isMoment(vars.endDate) ? (
      vars.endDate.unix()
    ) : (
      uiState.endDate.unix()
    );

    const preparedVars = {
      ...vars,
      startDate,
      endDate,
    };
    return preparedVars;
  },
  fragments: {
    viewer: (vars) => Relay.QL`
      fragment on Viewer {
        contact(email: $selectedContactEmail) @skip(if: $showMeetingRoom) @skip(if: $showOtherResource) {
          id
          displayName
          title
          department
          email
          city
          mobile
          events (first: 10000, startDate: $startDate, endDate: $endDate) {
            edges {
              node {
                subject
                body
                startDate
                endDate
                location {
                  displayName
                }
                isAllDay
                organizer {
                  displayName
                }
                requiredAttendees {
                  displayName
                  responseType
                }
                optionalAttendees {
                  displayName
                  responseType
                }
              }
            }
          }
        }
        meetingRooms(first: 1 , emails: $emails) @include(if: $showMeetingRoom) {
          edges {
            node {
              id
              displayName
              email
              events (first: 10000, startDate: $startDate, endDate: $endDate) {
                edges {
                  node {
                    id
                    subject
                    body
                    startDate
                    endDate
                    location {
                      displayName
                    }
                    isAllDay
                    occupancy
                    organizer {
                      displayName
                    }
                    requiredAttendees {
                      displayName
                      responseType
                    }
                    optionalAttendees {
                      displayName
                      responseType
                    }
                  }
                }
              }
            }
          }
        }
        otherResources(first: 1 , emails: $emails) @include(if: $showOtherResource) {
          edges {
            node {
              id
              displayName
              title
              email
              city
              mobile
              events (first: 10000, startDate: $startDate, endDate: $endDate) {
                edges {
                  node {
                    id
                    subject
                    body
                    startDate
                    endDate
                    location {
                      displayName
                    }
                    isAllDay
                    occupancy
                    organizer {
                      displayName
                    }
                    requiredAttendees {
                      displayName
                      responseType
                    }
                    optionalAttendees {
                      displayName
                      responseType
                    }
                  }
                }
              }
            }
          }
        }
        ${Favourite.getFragment('favourite', { selectedContactEmail: vars.selectedContactEmail })},
        ${CreateEventModal.getFragment('viewer')},
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/ContactInfo.js